module.exports = __webpack_public_path__ + "media/images/icons/institution-4087595fd942512ea615081a5d6e00c4.svg";